// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__2uJJt","title":"Info_title__1zkJg","links":"Info_links__22izN","link":"Info_link__2WSdU","logo":"Info_logo__f5DI9"};